import { ServicePriceModel } from '@fleet/model';

export const defaultServicePrice: ServicePriceModel = {
  defaultService: true,
  displayName: 'Standard',
  description: 'Standard taxi with 4 passengers or less',
} as any;
